import { Image } from '@tiptap/extension-image';

/**
 * 自定义图片扩展
 * 扩展了基础图片组件，添加了额外的属性支持
 * 用于图片的定位、追踪和样式控制
 */
export const CustomImage = Image.extend({
    name: 'customImage',

    addAttributes() {
        // 获取原有属性
        const baseAttributes = this.parent?.() || {};

        return {
            ...baseAttributes, // 保留原有属性
            id: {
                // 添加 id 属性
                default: null,
                parseHTML: (element) => element.getAttribute('id'),
                renderHTML: (attributes) => ({
                    id: attributes.id,
                }),
            },
            // 图片源地址
            src: {
                default: null,
            },
            // 图片替代文本，用于存储图片ID和章节ID
            alt: {
                default: null,
            },
            // 图片标题
            title: {
                default: null,
            },
            // 图片宽度
            width: {
                default: '100%',
            },
        };
    },
});
